import './main.css';

import { IonCard, IonCardTitle, IonCol, IonGrid, IonRow } from '@ionic/react';
import { _cachedLocalAutoL2image, _debugMode, _dict, _emptyLabel, _libName, _pathSeparator, _photoPrefix, _possibleCardColors, _rootName, _soundPrefix } from './constants';
import { displayPic, isYoutubeUrl } from './usePhotoGallery';
import { logMe } from '../foo/user';
import { useUIStore } from './stateManagement/UIZustand';




interface CardProps {
  label: string;
  description: string;
  videoURL: string;

}

function Card(props: CardProps){
  const {setVideoURL} = useUIStore();

  const handleCardClick = () => {
    if(isYoutubeUrl(props.videoURL)){
      setVideoURL(props.videoURL);
      logMe("click_helpCard_"+props.label.replace(/[^a-zA-Z0-9]/g, ''),{});
    }    
  };


  return ( 
    <IonCard
    className="mediumCards"
    onClick={handleCardClick}
    
    >
      <IonGrid>
        <IonRow>
          <IonCol>
            <IonCardTitle className={"ion-text-center cardTitleMedium"}>
              {props.label}
            </IonCardTitle>
            <p>
              {props.description}
            </p>
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol>
            <IonCardTitle className="ion-text-center">
              {displayPic(props.videoURL, false)}
            </IonCardTitle>
          </IonCol>
        </IonRow>
      </IonGrid>
      
    </IonCard>
    
  );
}
export default Card;